import { Button } from '@mantine/core';
import React from 'react';

interface PrimaryButtonProps {
  text: string;
  type?: 'submit' | 'button';
  leftSection?: React.ReactNode;
  rightSection?: React.ReactNode;
  isDelete?: boolean;
  onClick?: () => void;
  loading?: boolean; // Add loading prop
  disabled?: boolean; // Add disabled prop
}

const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  text,
  type,
  leftSection,
  rightSection,
  isDelete = false,
  onClick,
  loading = false,
  disabled = false
}) => {
  return (
    <Button
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      type={type === 'submit' ? 'submit' : 'button'}
      variant='filled'
      color={isDelete ? 'red' : disabled ? 'gray' : '#7B2183'}
      loading={loading}
      leftSection={leftSection}
      rightSection={rightSection}
    >
      {text}
    </Button>
  );
};

export default PrimaryButton;
